import React, {FC, useState} from 'react';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {IWinnerTicket, IWish} from "../../../store/wish/Helper";
import ViewWinnersDialog from "../../dialogs/view-winners-dialog/ViewWinnersDialog";

interface IProps {
    wish: IWish;
    winners: IWinnerTicket[];
    buttonColor?: "primary" | "secondary" | "tertiary";
    buttonSize?: "small" | "medium";
}

const WinnersButton: FC<IProps> = ({wish, winners, buttonColor = "primary", buttonSize = "small"}) => {
    const {t} = useTranslation();
    const [openDialog, setOpenDialog] = useState(false);

    const handleOpenDialog = (e: React.MouseEvent) => {
        e.stopPropagation();
        setOpenDialog(true);
    };

    return (
        <Box px={1} pb={1}>
            <Button
                variant="contained"
                color={buttonColor}
                fullWidth
                size={buttonSize}
                onClick={handleOpenDialog}
            >
                {t('see_winners', {count: wish.number_of_winners})}
            </Button>
            <ViewWinnersDialog
                wish={wish}
                winners={winners}
                open={openDialog}
                handleDialogClose={() => setOpenDialog(false)}
            />
        </Box>
    );
};

export default WinnersButton;
